import { useEffect, useState } from "react";
import {
  notificationSettingsRepo,
  DEFAULT_NOTIFICATION_SETTINGS,
  type NotificationSettings,
} from "@/services/notification_settings.repository";

/** 상단바 알림 표시 항목(system_settings/notification_settings) 구독. */
export function useNotificationSettings() {
  const [settings, setSettings] = useState<NotificationSettings>(DEFAULT_NOTIFICATION_SETTINGS);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const unsub = notificationSettingsRepo.watch(
      (s) => { setSettings(s); setLoaded(true); },
      () => setLoaded(true),
    );
    return unsub;
  }, []);

  return { settings, loaded };
}
